import Vue from "vue";
import Router from "vue-router";
import AuthLogin from "@/views/AuthLogin.vue";
import DashboardApp from "@/views/DashboardApp.vue";
import EmployeeApp from "@/views/EmployeeApp.vue";
import ParameterApp from "@/views/ParameterApp.vue";
import SuggestionApp from "@/views/SuggestionApp.vue";
import ChangePassword from "@/views/ChangePassword.vue";
import ProfileApp from "@/views/ProfileApp.vue";
import RequestResetPassword from "@/views/RequestResetPassword.vue";
import ResetPassword from "@/views/ResetPassword.vue";
import WorkflowSteps from "@/views/WorkflowSteps.vue";
import ApprovalApp from "@/views/ApprovalApp.vue";
import ImplementApp from "@/views/ImplementApp.vue";
import RedeemApp from "@/views/RedeemApp.vue";
import ValidationApp from "@/views/ValidationApp.vue";
import VerificationPoint from "@/views/VerificationPoint.vue";
import ReportStatus from "@/views/ReportStatus.vue";
import ReportAssessment from "@/views/ReportAssessment.vue";
import ReportAssessmentTopIdea from "@/views/ReportAssessmentTopIdea.vue";
import ReportHistory from "@/views/ReportHistory.vue";
import ReportDepartment from "@/views/ReportDepartment.vue";
import ReportEmployee from "@/views/ReportEmployee.vue";
import NotFound from "@/components/NotFound.vue";
import store from "@/store"; // Import Vuex store

// unlogin
import SuggestionUnlogin from "@/views/SuggestionUnlogin.vue";

Vue.use(Router);

const router = new Router({
  mode: "history", // Gunakan mode history untuk menghilangkan hash (#) di URL
  routes: [
    {
      path: "/",
      component: SuggestionApp,
      meta: { requiresAuth: true }, // Menandai bahwa route ini membutuhkan autentikasi
    },
    {
      path: "/login",
      name: "login",
      component: AuthLogin,
      beforeEnter: (to, from, next) => {
        const tokenJwt = to.query.token_jwt; // Ambil token dari query parameter

        if (tokenJwt) {
          store.dispatch("user/saveJwtToken", tokenJwt);
          window.history.replaceState(null, "", to.path);
          return next({ name: "Suggestions" });
        }

        if (store.getters["user/getJwtToken"]) {
          return next({ name: "Suggestions" });
        }

        // Jika tidak ada token, tetap di halaman login
        next();
      },
    },
    {
      path: "/request-reset-password",
      name: "request-reset-password",
      component: RequestResetPassword,
    },
    {
      path: "/reset-password/:token",
      name: "reset-password",
      component: ResetPassword,
      props: true, // token_jwt akan diteruskan ke komponen sebagai prop
    },

    {
      path: "/dashboard",
      name: "Dashboard",
      component: DashboardApp,
      meta: { requiresAuth: true }, // Menandai bahwa route ini membutuhkan autentikasi
    },

    {
      path: "/suggestions",
      name: "Suggestions",
      component: SuggestionApp,
      meta: { requiresAuth: true }, // Menandai bahwa route ini membutuhkan autentikasi
    },
    {
      path: "/profile",
      name: "profile",
      component: ProfileApp,
      meta: { requiresAuth: true }, // Menandai bahwa route ini membutuhkan autentikasi
    },

    {
      path: "/employees",
      name: "employee",
      component: EmployeeApp,
      meta: { requiresAuth: true }, // Menandai bahwa route ini membutuhkan autentikasi
    },
    {
      path: "/change-password",
      name: "change-password",
      component: ChangePassword,
      meta: { requiresAuth: true }, // Menandai bahwa route ini membutuhkan autentikasi
    },
    {
      path: "/workflow-steps",
      name: "workflow-steps",
      component: WorkflowSteps,
      meta: { requiresAuth: true }, // Menandai bahwa route ini membutuhkan autentikasi
    },
    {
      path: "/parameters",
      name: "parameter",
      component: ParameterApp,
      meta: { requiresAuth: true }, // Menandai bahwa route ini membutuhkan autentikasi
    },
    {
      path: "/approvals",
      name: "approvals",
      component: ApprovalApp,
      meta: { requiresAuth: true }, // Menandai bahwa route ini membutuhkan autentikasi
    },
    {
      path: "/implements",
      name: "implements",
      component: ImplementApp,
      meta: { requiresAuth: true }, // Menandai bahwa route ini membutuhkan autentikasi
    },
    {
      path: "/point/redeem",
      name: "redeem",
      component: RedeemApp,
      meta: { requiresAuth: true }, // Menandai bahwa route ini membutuhkan autentikasi
    },
    {
      path: "/point/verification",
      name: "verification",
      component: VerificationPoint,
      meta: { requiresAuth: true }, // Menandai bahwa route ini membutuhkan autentikasi
    },
    {
      path: "/point/validation/:id/:token",
      name: "validation",
      component: ValidationApp,
    },
    {
      path: "/report/status",
      name: "reportStatus",
      component: ReportStatus,
      meta: { requiresAuth: true }, // Menandai bahwa route ini membutuhkan autentikasi
    },
    {
      path: "/report/department",
      name: "reportDepartment",
      component: ReportDepartment,
      meta: { requiresAuth: true }, // Menandai bahwa route ini membutuhkan autentikasi
    },
    {
      path: "/report/assessment",
      name: "ReportAssessment",
      component: ReportAssessment,
      meta: { requiresAuth: true }, // Menandai bahwa route ini membutuhkan autentikasi
    },
    {
      path: "/report/assessment-top-idea",
      name: "ReportAssessmentTopIdea",
      component: ReportAssessmentTopIdea,
      meta: { requiresAuth: true }, // Menandai bahwa route ini membutuhkan autentikasi
    },
    {
      path: "/report/history",
      name: "ReportHistory",
      component: ReportHistory,
      meta: { requiresAuth: true }, // Menandai bahwa route ini membutuhkan autentikasi
    },
    {
      path: "/report/employee",
      name: "reportEmployee",
      component: ReportEmployee,
      meta: { requiresAuth: true }, // Menandai bahwa route ini membutuhkan autentikasi
    },
    {
      path: "/suggestion-unlogin",
      name: "suggestion-unlogin",
      component: SuggestionUnlogin,
    },
    { path: "*", component: NotFound, meta: { requiresAuth: true } }, // Route not found
  ],
});

// Navigation guard untuk memeriksa autentikasi
router.beforeEach((to, from, next) => {
  // Jika route membutuhkan autentikasi
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // console.log(this.$route.query.token_jwt);

    const token_jwt = store.getters["user/getJwtToken"];
    if (!token_jwt) {
      // Jika token_jwt tidak ada, arahkan ke halaman login
      next({ name: "login" });
      // next();
    } else {
      // Jika token_jwt ada, lanjutkan ke route tujuan
      next();
    }
  } else {
    // Jika route tidak membutuhkan autentikasi, lanjutkan ke route tujuan
    next();
  }
});

export default router;
